export default "__VITE_ASSET__Z_U2k3dX__"